<template>
  <div class="is-hidden-print">
    <!-- Touch -->
    <b-navbar fixed-top :active.sync="isNavbarOpen" class="is-hidden-desktop">
      <template slot="brand">
        <b-navbar-item tag="router-link" :to="{ name: $consts.urls.URL_ROOT }">
          <img :src="require('@/assets/logo-core.svg')" style="position: relative; top: 6px" alt="Plateforme Core" />
        </b-navbar-item>
      </template>
      <template slot="start" v-if="!isLoading">
        <div class="m-12px">
          <nav-super-admin v-if="isSuperAdmin" />
          <nav-user v-else />
        </div>
      </template>
    </b-navbar>
    <!-- Desktop -->
    <div class="is-hidden-touch">
      <router-link :to="{ name: $consts.urls.URL_ROOT }">
        <img class="image" :src="require('@/assets/logo-core.svg')" alt="Plateforme Core" />
      </router-link>
      <div v-if="!isLoading" class="mt-24px">
        <nav-super-admin v-if="isSuperAdmin" />
        <nav-user v-else />
      </div>
    </div>
  </div>
</template>

<script>
import NavUser from '@/components/nav/nav-user'
import NavSuperAdmin from '@/components/nav/nav-super-admin'
import AuthentificationService from '@/services/authentification'
import { USER_TYPE_SYSTEM_ADMIN } from '@/consts/enums'

export default {
  components: {
    NavUser,
    NavSuperAdmin
  },
  watch: {
    $route() {
      this.isNavbarOpen = false
    }
  },
  data() {
    return {
      isSuperAdmin: false,
      isLoading: true,
      isNavbarOpen: false
    }
  },
  async beforeMount() {
    var userType = await AuthentificationService.getUserType()
    this.isSuperAdmin = userType == USER_TYPE_SYSTEM_ADMIN
    this.isLoading = false
  }
}
</script>

<style lang="scss">
.navbar-burger {
  &:focus,
  &:hover {
    background-color: $white !important;
  }
  &.is-active {
    background-color: $grey-light !important;
    color: $white;
  }
}

@include tablet {
  .navbar {
    padding: 0 20px;
  }
}

// Hot fix to remove navbar added padding
// when invisible on desktop
@include desktop {
  html.has-navbar-fixed-top,
  body.has-navbar-fixed-top {
    padding-top: 0 !important;
  }
}
</style>